var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","name":"button"},on:{"click":_vm.setEnd}},[_vm._v(" END ")])])}
var staticRenderFns = []

export { render, staticRenderFns }